import {email} from '@rocket-ui/tools';

export const EMAIL_INVALID_MESSAGE = 'Неверный e-mail';

export function isProfileEmailValid(value: string): boolean {
	const trimmed = value.trim();

	if (!trimmed) {
		return false;
	}

	return email.isValidEmail(trimmed);
}

/** Ошибка под полем: показываем, когда значение непустое и не проходит проверку. */
export function getProfileEmailError(value: string): string | null {
	const trimmed = value.trim();

	if (!trimmed || isProfileEmailValid(trimmed)) {
		return null;
	}

	return EMAIL_INVALID_MESSAGE;
}
